<template>
  <transition name="el-fade-in-linear">
    <div v-show="transitionshow">

      <el-form :inline="true" class="demo-form-inline backborder1" size="small">
        <el-form-item ref="search">
          <el-input placeholder="请输入条形码" v-model="productquery.key" @keyup.enter.native="addDialogsingle">
            <template slot="prepend">查找</template>
            <el-button slot="append" icon="el-icon-search" @click="addDialogShow"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="addDialogShow" :disabled="!create.delivery">添加调拨商品</el-button>
        </el-form-item>
      </el-form>


      <!-- 基础数据信息 -->
      <div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
        <div class="cz-sell-base-lists-infos-out">
          <!-- 调拨单号 -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">调拨单号</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input v-model="create.documents" placeholder="单据编号" :disabled="true" />
            </div>
          </div>

          <!-- 调拨日期 -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">调拨日期</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-date-picker type="date" placeholder="请选择付款日期" v-model="create.allotdate" style="width:99%;"
                value-format="yyyy-MM-dd" />
            </div>
          </div>
          <!-- 发货仓库 -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">发货仓库</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.send" placeholder="请选择发货仓库" @change="outWarehouseChange">
                <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                  v-if="lists == ''"></el-option>
                <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                  v-if="lists != '' && create.send != item.id" disabled></el-option>
                <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name" :value="item.id"
                  v-if="lists != '' && create.send == item.id"></el-option>
              </el-select>
            </div>
          </div>

          <!-- 收货仓库 -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">收货仓库</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-select v-model="create.delivery" placeholder="请选择收货仓库" @change="inWarehouseChange">
                <el-option v-for="(item, index) in wareHouseLists" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </div>
          </div>

          <!--备注 -->
          <div class="cz-sell-base-lists-infos">
            <span class="cz-sell-base-lists-infos-title">备注信息</span>
            <div class="cz-sell-base-lists-infos-content">
              <el-input v-model="create.note" placeholder="请填写备注" clearable />
            </div>
          </div>
        </div>

        <div class="cz-sell-base-lists-infos-goods">
          <el-table :data="lists" :border="true" v-loading="listLoading" show-summary :summary-method="totalRule">
            <el-table-column prop="name" label="商品信息" min-width="300">
              <template slot-scope="scope">
                <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{ scope.row.name }}</span>
                <span style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999"
                  v-if="scope.row.number != ''">编号：{{ scope.row.number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="单位" min-width="120" align="center">
              <template slot-scope="scope">
                <el-input size="small" :value="scope.row.unit" readonly @focus="changeUnit(scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="数量" min-width="120" align="center">
              <template slot-scope="scope">
                <el-input size="small" v-model="nums[scope.$index]"
                  @blur="changeNum(scope.$index, scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="售价" min-width="120" align="center">
              <template slot-scope="scope">
                <span style="float:left;width:100%;font-size:13px;line-height:23px;">{{ scope.row.sell }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="小计" min-width="120" align="center">
              <template slot-scope="scope">
                <el-input size="small" v-model="totals[scope.$index]"
                  @blur="changeTotal(scope.$index, scope.row)"></el-input>
              </template>
            </el-table-column>
            <el-table-column v-if="storageLocationStatus" prop="name" label="调出货位" min-width="180" align="center">
              <template slot-scope="scope">
                <el-select v-model="storageLocationOutIds[scope.$index]" placeholder="请选择调出货位"
                  @change="changeStorageLocationOutId(scope.$index, scope.row)">
                  <el-option v-for="item in filteredOptions[scope.row.productid]" :key="item.id" :label="item.full_code"
                    :value="item.id + ''"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <!-- ************************* -->
            <el-table-column v-if="storageLocationStatus" prop="name" label="调入货位" min-width="120" align="center">
              <template slot-scope="scope">
                <!-- <el-select v-model="storageLocationInIds[scope.$index]" placeholder="请选择调入货位"
                  @change="changeStorageLocationInId(scope.$index, scope.row)">
                  <el-option v-for="item in inTerrList" :key="item.id" :label="item.full_code"
                    :value="item.id"></el-option>
                </el-select> -->

                <div class="link-style" @click="showSelectLocation(scope.$index)">
                  <span v-if="!storageLocationInIds[scope.$index]">请选择</span>
                  <span v-else>{{ scope.row.full_code }}</span>
                </div>
              </template>
            </el-table-column>
            <!-- *************************** -->
            <el-table-column prop="validity" label="批次号" min-width="155" align="center" v-if="batchStatus">
              <template slot-scope="scope">
                <div class="link-style" @click="switchingBatches(scope.row, storageLocationOutIds[scope.$index])">
                  <span>{{ scope.row.batch_sn || '无批次' }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="start_date" label="生产日期" align="center" v-if="batchStatus">
              <template slot-scope="scope">
                {{ scope.row.start_date || "/" }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="有效期" align="center" v-if="batchStatus">
              <template slot-scope="scope">
                <span v-if="scope.row.realvalidity">
                  {{ scope.row.realvalidity }}{{ validityunitTemp[scope.row.validityunit] }}
                </span>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <el-table-column prop="end_date" label="到期日期" align="center" v-if="batchStatus">
              <template slot-scope="scope">
                {{ scope.row.end_date || "/" }}
              </template>
            </el-table-column>


            <el-table-column label="删除" min-width="120" align="center">
              <template slot-scope="scope">
                <el-button type="" size="small" round @click="delCurrent(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="cz-sell-order-stat">
          <div class="cz-sell-order-stat-totals"></div>
          <div class="cz-sell-order-stat-handles">
            <el-button size="small" type="warning" :loading="createsaveloading" @click="createSave">保存</el-button>
          </div>
        </div>

      </div>



      <!---------------------------修改单位--------------------------->
      <el-dialog title="单位选择" :visible.sync="unitDialog">
        <el-table :data="unitlists" style="width: 100%" v-loading="unitListLoading">
          <el-table-column label="单位" prop="unit"></el-table-column>
          <el-table-column label="售价" prop="sell"></el-table-column>
          <el-table-column label="市场价" prop="market"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" circle icon="el-icon-check"
                @click="changeUnitSave(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>

      <!---------------------------批量添加--------------------------->
      <el-dialog title="添加产品" :visible.sync="addDialog" width="60%" top="1vh">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌" @change="selectbrand">
              <el-option label="不分品牌" value="0"></el-option>
              <el-option v-for="(item, index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #C0C4CC; font-size: 13px">{{ item.py }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item ref="productquery" :model="productquery">
            <el-input placeholder="商品名称 / 编号 / 条形码 / 拼音码" v-model="productquery.key" clearable
              @keyup.enter.native="getProductList(create.send)" @change="isnewselect = true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="getProductList(create.send)">查询</el-button>
          </el-form-item>
        </el-form>
        <!------------------------search end---------------------->
        <el-table :data="productlists" ref="multipleTable" style="width: 100%" v-loading="addListLoading"
          tooltip-effect="dark" @row-click="handleSelectRow" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="80"></el-table-column>
          <el-table-column prop="number" label="商品" min-width="250">
            <template slot-scope="scope">
              <span style="display:inline-block;width:100%;font-size:13px;line-height:23px;">{{ scope.row.name }}</span>
              <span style="display:inline-block;width:100%;font-size:12px;line-height:23px;color:#999999">编号：{{
                scope.row.number }}</span>
            </template>
          </el-table-column>
          <el-table-column label="库存" min-width="150" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.inventory > 0">{{ scope.row.inventory }}</span>
              <span v-if="scope.row.inventory == 0" style="color:#F56C6C">{{ scope.row.inventory }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="productPageSizeChange" @current-change="productPageCurrentChange"
            :current-page="productquery.p" :page-sizes="[10, 20, 50]" :page-size="productquery.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="total_product_rows">
          </el-pagination>
          <!--分页end-->
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="warning" :loading="addProductLoading" @click="addSave">确认添加</el-button>
        </div>
      </el-dialog>

      <!---------------------------修改货位--------------------------->
      <el-dialog title="选择货位" :visible.sync="locationDialog" @close="locationParams.keyword = ''">
        <el-form :inline="true" class="demo-form-inline" size="small">
          <el-form-item>
            <el-input placeholder="请输入搜索关键词" v-model="locationParams.keyword" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="locationSearch()">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="locationList" style="width: 100%" v-loading="locationDialogLoading">
          <el-table-column label="货位号" align="left" header-align="center" prop="full_code"></el-table-column>
          <el-table-column label="选择" width="80">
            <template slot-scope="scope">
              <el-button type="primary" size="small" icon="el-icon-check"
                @click="selectLocation(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <!--分页begin-->
          <el-pagination @size-change="locationPageSizeChange" @current-change="locationPageCurrentChange"
            :current-page="locationParams.p" :page-sizes="[10, 20, 50]" :page-size="locationParams.rollpage"
            layout="total, sizes, prev, pager, next, jumper" :total="locationParams.total">
          </el-pagination>
          <!--分页end-->
        </div>
      </el-dialog>


      <ChangeBatch ref="ChangeBatch" selectType="2" :isOut="true" @confirm="batchConfirm" />
    </div>
  </transition>
</template>

<script>
import ChangeBatch from '@/components/home/ChangeBatch.vue';
export default {
  components: { ChangeBatch },
  data() {
    return {
      url: this.GLOBAL.domain + "Allot/index",
      transitionshow: true,
      actionauth: [],
      create: {
        act: 'add',
        token: this.$cookies.get('token'),
        send: '',
        delivery: '',
        allotdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        documents: '',
        inputdate: new Date().getFullYear().toString() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
        note: '',
      },
      wareHouseLists: [],
      productquery: {
        act: 'getproduct',
        token: this.$cookies.get('token'),
        brandid: '',
        warehouse: '',
        key: '',
        rollpage: 10, // 页大小
        p: 1
      },
      lists: [],
      listLoading: false,
      totals: [],
      addallotDialog: false,
      createsaveloading: false,
      query: {
        act: 'lists',
        token: this.$cookies.get('token'),
        rollpage: 1000, // 页大小
        p: 1
      },
      nums: [],
      totals: [],
      validitys: [],
      total_rows: 0,
      brandlists: [],
      multipleSelection: [],
      addDialog: false,
      unitDialog: false,
      unitListLoading: false,
      changeunitid: 0,
      unitlists: [],
      addProductLoading: false,
      productlists: [],
      addListLoading: false,
      isnewselect: false,
      total_product_rows: 0,
      storageLocationStatus: false, // 货位功能开关
      outTerrList: [], // 出库货位列表
      storageLocationOutIds: [],
      inTerrList: [],  // 入库货位列表
      storageLocationInIds: [],
      locationDialog: false,
      locationList: [],
      locationDialogLoading: false,
      locationParams: {
        keyword: '',
        rollpage: 10,
        p: 1,
        total: 0
      },
      editListIndex: '',
      validityunitTemp: {
        1: '日',
        2: '月',
        3: '年'
      },
      batchStatus: false
    }
  },
  computed: {
    // 计算属性用于生成每个行的过滤后的选项列表
    filteredOptions() {
      const result = {};
      this.lists.forEach(row => {
        result[row.productid] = this.outTerrList.filter(option =>
          option.product_ids.includes(+row.productid)
        );
      });
      return result;
    }
  },
  created() {
    // 获取货位功能是否开启状态
    this.storageLocationStatus = localStorage.getItem("storageLocationStatus") === 'true'
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
  },

  mounted() {
    this.getactionauth(); //获取权限设置
    this.getWarehouse(); //获取仓库信息列表
    this.getBrand(); //商品品牌信息
    this.getList();
    this.setDocuments();
  },


  methods: {
    batchConfirm({row, batchRow}) {
      this.batchUpdate(row, batchRow)
    },
    async batchUpdate(row, batchRow) {
      try {
          const res = await this.$axios({
            url: this.GLOBAL.domain + 'Allot/index',
            method: 'post',
            data: { 
              act: 'allot_batch_update',
              id: row.id,
              product_batch_id: batchRow.product_batch_id
            }
          });
          // 刷新列表
          this.getList()
          return res;
        } catch (err) {
          console.error('请求异常:', err);
        }
    },
    switchingBatches(row, fromLocation) {
      // 如果没有选择发货仓库或者没有选择调出货位，不允许选择批次
      if (!this.create.send || !fromLocation) {
        this.$message.error('请选择发货仓库和调出货位')
        return
      }
      this.$refs.ChangeBatch.openDialog(row, this.create.send, fromLocation)
    },
    // 调出货位变更
    changeStorageLocationOutId(index, row) {
      this.editLocationById(index, row, 1)
    },
    // 调入货位变更
    changeStorageLocationInId(index, row) {
      this.editLocationById(index, row, 2)
    },
    // 编辑货位
    editLocationById(index, row, type) {
      // type 类型。1:修改调出货位 2:修改调入(收货)货位
      this.$axios({
        url: this.GLOBAL.domain + 'Allot/index',
        method: 'post',
        data: {
          act: 'changeStorageLocation',
          id: row.id,
          warehouse_id: type == 1 ? this.create.send : this.create.delivery,
          storage_location_id: type == 1 ? this.storageLocationOutIds[index] : this.storageLocationInIds[index],
          type: type
        }
      })
        .then(res => {
          this.$message.success('修改货位成功')
        })
        .catch(err => {
          this.$nextTick(() => {
            if (type == 1) {
              // this.storageLocationOutIds[index] = '' 不起作用
              this.$set(this.storageLocationOutIds, index, '')
            }
            if (type == 2) {
              // this.storageLocationInIds[index] = ''
              this.$set(this.storageLocationInIds, index, '')
            }
          })

        })
        .finally(() => {
          this.getList()
        })

    },
    outWarehouseChange() {
      this.getTerrList(this.create.send, 'outTerrList')
    },
    inWarehouseChange() {
      this.getTerrList(this.create.delivery, 'inTerrList')
      this.storageLocationInIds = []
    },
    // 获取货位下拉列表
    getTerrList(warehouse_id, key) {
      this.$axios({
        url: this.GLOBAL.domain + 'StorageLocation/select_list',
        method: 'post',
        data: {
          warehouse_id
        }
      })
        .then(res => {
          this[key] = res.Data.data
        })
    },
    /** 重置表单 **/
    reset() {
      this.$refs.create.resetFields();
    },

    /** 获取操作功能权限 **/
    getactionauth() {
      var data = this.$cookies.get('actionauth');
      data = JSON.parse(data);
      this.actionauth = data;
    },

    /** 获取品牌 **/
    getBrand() {
      var resource = this.$resource(this.GLOBAL.domain + "Brand/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 获取仓库 **/
    getWarehouse() {
      var resource = this.$resource(this.GLOBAL.domain + "Ware/index");
      resource.query({ act: 'lists', token: this.$cookies.get('token'), rollpage: 1000 }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        } else {
          this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },

    /** 进货单号 **/
    setDocuments() {
      var currentDate = new Date();
      var month = currentDate.getMonth() + 1;
      var doc = 'DB' + currentDate.getFullYear() + month + currentDate.getDate() + currentDate.getHours() + currentDate.getMinutes();
      this.create.documents = doc;
    },

    /** 信息列表 **/
    getList() {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          if (this.lists != '') this.create.send = this.lists[0]['warehouseid'];
          if (this.create.send) {
            this.getTerrList(this.create.send, 'outTerrList')
          }
          const _this = this;
          this.lists.forEach(function (e, index) {
            _this.nums.splice(index, 1, e.num);
            _this.totals.splice(index, 1, e.total);
            _this.validitys.splice(index, 1, e.validity);
            if (e.from_storage_location_id == 0 || e.from_storage_location_id == '') {
              _this.storageLocationOutIds.splice(index, 1, '')
            } else {
              _this.storageLocationOutIds.splice(index, 1, e.from_storage_location_id)
            }

          });
          this.total_rows = parseInt(res.data.count);
          this.listLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },

    totalRule() {
      var _this = this;
      var num = 0;
      var total = 0;
      this.lists.forEach(function (e, index) {
        num += parseInt(e.num);
        total += parseFloat(e.total);
      });

      total = total.toFixed(2);
      return ['合计', '', num, '', total, ''];
    },


    pageSizeChange(val) {
      this.query.rollpage = val;
      this.getList();
    },
    pageCurrentChange(val) {
      this.query.p = val;
      this.getList();
    },

    /** 扫码添加商品 **/
    addDialogsingle() {
      if (this.create.send == '' || this.create.send == null) {
        this.$message.error('请先选择发货仓库！');
        return false;
      }
      var resource = this.$resource(this.url);
      resource.query({ act: 'sweep', key: this.productquery.key, warehouse: this.create.send, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
        } else {
          if (Base64.decode(res.data.Data) == 1) { //有1个以上则展开列表 
            this.addDialogShow();
            this.productquery.key = '';
          } else { //扫码解析同一个产品只有1个则直接添加
            this.multipleSelection = [];
            this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
            this.addSave();
            this.productquery.key = '';
          }
        }
      }).catch((res) => {

      });
    },

    /** 批量添加 **/
    addDialogShow() {
      if (this.create.send == '' || this.create.send == null) {
        this.$message.error('请先选择发货仓库！');
        return false;
      }
      this.getBrand();
      this.getProductList(this.create.send);
      this.addDialog = true;
    },

    /** 修改单位 **/
    changeUnit(item) {
      this.unitDialog = true;
      this.unitListLoading = true;
      this.changeunitid = item.id;
      var resource = this.$resource(this.url);
      resource.query({ act: 'getunit', productid: item.productid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
        } else {
          this.unitlists = JSON.parse(Base64.decode(res.data.Data));
          this.unitListLoading = false;
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
    },

    /** 确认修改单位 **/
    changeUnitSave(item) {
      this.unitListLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changeunit', id: item.id, tempid: this.changeunitid, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.unitListLoading = false;
          this.getList();
        } else {
          this.unitListLoading = false;
          this.$message.success("修改单位信息成功！");
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.unitListLoading = false;
      });
      this.unitDialog = false;
    },

    /** 修改数量 **/
    changeNum(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changenum', id: item.id, num: this.nums[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
          this.getList();
        } else {
          this.$message.success('修改商品数量成功！');
          this.listLoading = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },

    /** 修改总价 **/
    changeTotal(index, item) {
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'changetotal', id: item.id, total: this.totals[index], token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.listLoading = false;
        } else {
          this.listLoading = false;
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.listLoading = false;
      });
    },

    /** 删除 **/
    delCurrent(item) {
      this.$confirm('此操作将删除 ' + item.name + ', 是否继续?', '提示', { type: 'warning' })
        .then(() => {
          // 向请求服务端删除
          var resource = this.$resource(this.url);
          resource.save({ act: 'del', id: item.id, token: this.$cookies.get('token') })
            .then((res) => {
              if (res.data.Result > 0) {
                if (res.data.Result == '70001') {
                  this.$router.push('/login')
                }
                this.$message.error(res.data.Message);
              } else {
                this.$message.success('成功删除了' + item.name + '!');
                this.getList();
              }
            }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
            });
        })
        .catch(() => {
          this.$message.info('已取消操作!');
        });
    },

    /** 新增 **/
    createSave() {
      this.createsaveloading = true;
      var resource = this.$resource(this.url);
      //实时获取单据编号
      this.setDocuments();

      resource.save(this.create).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.createsaveloading = false;
        } else {
          this.$message.success(res.data.Message);
          this.addallotDialog = false;
          this.createsaveloading = false;
          this.setDocuments(); //更新单据编号
          this.getList();
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addallotDialog = false;
        this.createsaveloading = false;
      });
    },

    /** 确认添加产品到购物车 **/
    addSave() {
      this.addProductLoading = true;
      var resource = this.$resource(this.url);
      resource.save({ act: 'addproduct', productid: this.multipleSelection, warehouseid: this.create.send, token: this.$cookies.get('token') }).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.addProductLoading = false;
        } else {
          this.$message.success(res.data.Message);
          this.addDialog = false;
          this.addProductLoading = false;
          this.getList();
          // storageLocationInIds
          this.multipleSelection.forEach(() => {
            // 在this.storageLocationInIds数组最前面添加一个空值
            this.storageLocationInIds.unshift('')
          })
        }
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addDialog = false;
        this.addProductLoading = false;
      });
    },

    /** 点击单行选择产品 **/
    handleSelectRow(row, event, column) {
      var _this = this;
      var val = [];
      val.push(row);
      var number = 0;
      var id = row.id;
      var isin = [];

      this.productlists.forEach(function (e, index) {
        if (e.id == id) number = index;
      });
      this.$refs.multipleTable.toggleRowSelection(this.productlists[number]);
      this.multipleSelection.forEach(function (e, index) { isin.push(e.id) });

      //检测是否添加产品进购物车
      if (inArray(id, isin)) {
        this.multipleSelection.forEach(function (e, index) {
          if (e.id == id) this.multipleSelection.splice(index, 1);
        });
      } else {
        this.multipleSelection.push(row);
      }

    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /** 产品信息列表 **/
    getProductList(warehouse) {
      if (this.isnewselect == true) {
        this.productquery.p = 1;
        this.productquery.rollpage = 10;
      }

      this.addListLoading = true;
      var resource = this.$resource(this.url);
      this.productquery.warehouse = warehouse;
      resource.query(this.productquery).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') {
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
          this.addListLoading = false;
        } else {
          this.productlists = JSON.parse(Base64.decode(res.data.Data));
          this.total_product_rows = parseInt(res.data.count);
          this.addListLoading = false;
        }

        if (this.isnewselect == true) this.isnewselect = false;
      }).catch((res) => {
        this.$message.error(this.GLOBAL.errortext);
        this.addListLoading = false;
        if (this.isnewselect == true) this.isnewselect = false;
      });
    },

    productPageSizeChange(val) {
      this.productquery.rollpage = val;
      this.getProductList(this.create.send);
    },
    productPageCurrentChange(val) {
      this.productquery.p = val;
      this.getProductList(this.create.send);
    },

    /** 品牌搜索（品牌发生变化时触发一次搜索） **/
    selectbrand() {
      this.isnewselect = true;
      this.getProductList(this.create.send);
    },
    showSelectLocation(index) {
      this.editListIndex = index
      this.locationDropdownList()
    },
    locationSearch() {
      this.locationParams.p = 1
      this.locationDropdownList()
    },
    selectLocation(row) {
      this.storageLocationInIds[this.editListIndex] = row.id
      const list = JSON.parse(JSON.stringify(this.lists))
      list[this.editListIndex] = {
        ...list[this.editListIndex],
        storage_location_id: row.id,
        full_code: row.full_code,
      }
      this.lists = list

      this.locationDialog = false

      this.locationParams.p = 1
      this.locationList = []
      this.changeStorageLocationInId(this.editListIndex, this.lists[this.editListIndex])

    },
    locationDropdownList() {
      if (!this.create.delivery) {
        this.$message.error('请先选择收货仓库')
        return
      }
      this.locationDialog = true
      const address_url = this.GLOBAL.domain + "StorageLocation/select_list"
      const send_data = {
        warehouse_id: this.create.delivery,
        token: this.$cookies.get('token'),
        ...this.locationParams
      }
      var resource = this.$resource(address_url);
      this.locationDialogLoading = true
      resource.save(send_data).then((res) => {
        if (res.data.Result > 0) {
          this.locationList = []
          this.$message.error(res.data.Message);
        } else {
          var result = JSON.parse(Base64.decode(res.data.Data));
          if (Array.isArray(result.data) && result.data.length > 0) {
            for (const i of result.data) {
              i["id"] = i["id"].toString()
            }
          }
          this.locationList = result.data
          this.locationParams.total = result.total
        }
      }).catch((res) => {
        this.locationList = []
        this.$message.error(this.GLOBAL.errortext);
      }).finally(() => {
        this.locationDialogLoading = false
      })
    },
    locationPageSizeChange(val) {
      this.locationParams.rollpage = val;
      this.locationDropdownList();
    },
    locationPageCurrentChange(val) {
      this.locationParams.p = val;
      this.locationDropdownList();
    },
  }
}
</script>


<style type="text/css">
.link-style {
  cursor: pointer;
}

.link-style:hover {
  text-decoration: underline;
  color: #1488f5;
}

.backborder1 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 0 1%
}

.backborder2 {
  background: #fff;
  border-radius: 15px;
  border: 1px solid #ddd;
  padding: 1% 1% 3% 1%
}

.titlelists {
  float: left;
  width: 100%;
  padding: 0;
  margin: 0
}

.titlelists li {
  float: left;
  width: 33.3%;
  font-size: 15px;
  list-style-type: none
}

.cz-sell-base-lists-infos-out {
  display: inline-block;
  width: 100%;
}

.cz-sell-base-lists-infos {
  float: left;
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 0;
  width: 25%;
  height: 50px;
  overflow: hidden;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {
  float: left;
  text-align: right;
  font-size: 13px;
  line-height: 23px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {
  float: left;
  margin-left: 10px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {
  text-align: left;
  width: 220px;
  border-bottom: 1px solid #dcdfe6;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  height: 40px;
  line-height: 40px;
  font-size: 13px;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {
  box-shadow: none;
  border-bottom: 1px solid #dcdfe6;
}

.cz-sell-base-lists-infos .el-input.is-active .el-input__inner,
.cz-sell-base-lists-infos .el-input__inner:focus {
  border-color: #dcdfe6 !important;
}

.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {
  margin-top: 7px
}

.cz-sell-base-lists-infos-goods {
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}

.cz-sell-base-lists-infos-goods .el-table {
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  background: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table td,
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,
.cz-sell-base-lists-infos-goods .el-table .hover-row>td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {
  background: #E4E7ED;
  border-bottom: 1px solid #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-input__inner {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border-bottom: none;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 15px;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
}

.cz-sell-base-lists-infos-goods .el-input__inner:hover {
  box-shadow: none;
  border: none;
}

.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td,
.cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {
  background-color: #E4E7ED;
}

.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #E4E7ED;
}

.cz-sell-order-stat {
  width: calc(100%);
  height: 100px;
  position: relative;
  margin-top: 10px;
  margin-bottom: 20px;
  background: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cz-sell-order-stat-handles {
  padding: 10px 20px;
  height: 60px;
  border-left: 1px solid #EBEEF5;
  width: 30%;
  display: flex;
  justify-content: left;
  align-items: center;
  overflow: hidden;
}

.cz-sell-order-stat-totals {
  padding: 10px 20px;
  height: 100px;
  width: calc(100% - 30% - 40px - 40px - 1px);
  display: flex;
  justify-content: left;
  align-items: center;
  overflow: hidden;
}

.cz-sell-order-stat-totals-name {
  float: left;
  width: calc(25% - 30px) !important;
  padding: 3px 30px 0 0 !important;
  font-size: 13px;
}

.cz-sell-order-stat-totals-name-title {
  float: left;
  width: 80px;
}

.cz-sell-order-stat-totals-name-content {
  float: left;
  width: calc(100% - 100px - 10px - 30px);
  padding: 0 15px;
  color: red;
  font-weight: 550;
  font-size: 14px;
}

.cz-sell-order-stat-totals-name .el-input {
  width: calc(100% - 80px - 5px);
  font-size: 14px;
}

.cz-sell-order-stat-totals-name .el-input__inner {
  color: red;
  font-weight: 550;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border-bottom: 1px solid #c0c4cc !important;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  background: none;
  text-align: left;
}

.cz-sell-order-stat-totals-name .el-input__inner:hover {
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #c0c4cc !important;
  background: none;
}

.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner,
.cz-sell-order-stat-totals-name .el-input__inner:focus {
  border-color: #c0c4cc !important;
  background: none;
}
</style>


// WEBPACK FOOTER //
// src/components/home/Allotadd.vue